import React, { useState } from 'react';
import { DeploymentStage as StageType } from '../../../types/wordpress.type';
import DeploymentStage from './DeploymentStage';

interface DeploymentStagesProps {
  stages: StageType[];
}

const DeploymentStages: React.FC<DeploymentStagesProps> = ({ stages }) => {
  const [expandedStages, setExpandedStages] = useState<Set<number>>(new Set());

  const toggleExpand = (stageId: number) => {
    setExpandedStages((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(stageId)) {
        newSet.delete(stageId);
      } else {
        newSet.add(stageId);
      }
      return newSet;
    });
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Deployment Events</h3>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Detailed progress of each deployment stage</p>
      </div>
      <div className="p-6">
        <div className="space-y-0">
          {stages.map((stage) => (
            <DeploymentStage
              key={stage.id}
              stage={{ ...stage, expanded: expandedStages.has(stage.id) }}
              onToggleExpand={() => toggleExpand(stage.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeploymentStages;